/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Main website
const DEFAULT_WEBSITE = "https://moonvalley.me/";

// Country-specific websites
const WEBSITES = [
  {
    country: "SE",
    descriptor: "Swedish",
    greetings: "Välkommen!",
    msg: "Det ser ut som att du besöker oss från Sverige, skulle du vilja besöka vår svenska butik?",
    url: "https://se.moonvalley.me/"
  },
  {
    country: "NO",
    descriptor: "Norwegian",
    greetings: "Velkommen!",
    msg: "Det ser ut som du besøker oss fra Norge, vil du gå til vår norske butikk?",
    url: "https://no.moonvalley.me/"
  },
  {
    country: "CH",
    descriptor: "Swiss",
    greetings: "Willkommen!",
    msg: "Es sieht so aus, als ob Sie uns aus der Schweiz besuchen würden, möchten Sie unseren Schweizer Laden besuchen?",
    url: "https://ch.moonvalley.me/"
  },
  {
    country: "GB",
    descriptor: "UK",
    greetings: "Welcome!",
    msg: "It looks like you are visiting us from the UK, would you like to visit our UK store?",
    url: "https://uk.moonvalley.me/"
  }
];

// Popup HTML
const injected_popup = `
  <style>
    .custom_redir_popup {
      position: fixed;
      inset: 0;
      width: 100%;
      height: 100%;
      text-align: center;
      font-size: 1.1rem;
      color: black;
      z-index: 10000;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 16px;
      box-sizing: border-box;
    }

    .custom_redir_popup_inner {
      background-color: white;
      padding: 1rem;
      max-width: 520px;
      width: 90%;
      max-height: 88vh;
      overflow-y: auto;
      box-sizing: border-box;
      margin-left: 0;
      transform: none;
    }

    .custom_redir_image {
      display: block;
      margin: 0 auto 0.75rem auto;
      max-width: 90%;
      max-height: 180px;
      object-fit: contain;
    }

    .custom_redir_welcome {
      font-weight: 600;
      margin: 0 0 0.75rem 0;
      font-size: 1.5rem;
    }

    .custom_redir_message {
      margin: 0 0 0.75rem 0;
      font-size: 1.4rem;
      line-height: 1.35;
    }

    .custom_redir_cta_button a {
      display: inline-block;
      background-color: rgba(83, 27, 68, 1);
      color: white;
      font-weight: 400;
      padding: 0.5rem 1.25rem;
      text-decoration: none;
      margin-top: 0.4rem;
      font-size: 1.1rem;
    }

    @media screen and (max-width: 600px) {
      .custom_redir_popup {
        padding: 12px;
      }

      .custom_redir_popup_inner {
        width: 92%;
        max-height: 85vh;
        padding: 0.9rem;
      }

      .custom_redir_image {
        max-height: 130px;
      }

      .custom_redir_welcome {
        font-size: 1.25rem;
      }

      .custom_redir_message {
        font-size: 1rem;
        line-height: 1.35;
      }

      .custom_redir_cta_button a {
        font-size: 1rem;
        padding: 0.45rem 1rem;
      }
    }

    .dimmed-overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.6);
      z-index: 9999;
    }
  </style>

  <div class="dimmed-overlay"></div>
  <div class="custom_redir_popup">
    <div class="custom_redir_popup_inner">
      <img
        class="custom_redir_image"
        src="https://cdn.shopify.com/s/files/1/0028/7257/4025/files/1920_x_1080.jpg?v=1775568223"
        alt="Moonvalley"
      >
      <p class="custom_redir_welcome">%%APPDATA/GREETINGS%%</p>
      <p class="custom_redir_message">%%APPDATA/MSG%%</p>
      <div class="custom_redir_cta_button">
        <a id="custom_redir_cta_button_default" href="#">
          Main Store
        </a>
        <br>
        <a href="%%APPDATA/URI%%">
          %%APPDATA/DESCRIPTOR%% Store
        </a>
      </div>
    </div>
  </div>
`;

function removePopup() {
  const overlay = document.querySelector(".dimmed-overlay");
  const popup = document.querySelector(".custom_redir_popup");

  if (overlay) overlay.remove();
  if (popup) popup.remove();
}

function activate_event_listeners() {
  const defaultButton = document.getElementById("custom_redir_cta_button_default");

  if (defaultButton) {
    defaultButton.addEventListener("click", function (e) {
      e.preventDefault();
      removePopup();
      document.cookie = "popupShown=true; max-age=86400; path=/";
    });
  }
}

function checkAndShowPopup() {
  const popupShown = document.cookie.includes("popupShown=true");

  if (popupShown) {
    console.log("Popup has already been shown.");
    return;
  }

  fetch("https://www.cloudflare.com/cdn-cgi/trace")
    .then(response => response.text())
    .then(data => {
      console.log("Cloudflare trace:", data);

      const splitData = data.split("\n");
      let country = null;

      for (let i = 0; i < splitData.length; i++) {
        if (splitData[i].startsWith("loc=")) {
          country = splitData[i].split("=")[1];
          break;
        }
      }

      console.log("Detected country:", country);
      console.log("Current URL:", window.location.href);

      for (let i = 0; i < WEBSITES.length; i++) {
        if (country === WEBSITES[i].country) {
          const popupAlreadyExists = document.querySelector(".custom_redir_popup");
          if (popupAlreadyExists) return;

          const preprocessed_msg = injected_popup
            .replace("%%APPDATA/MSG%%", WEBSITES[i].msg)
            .replace("%%APPDATA/URI%%", WEBSITES[i].url)
            .replace("%%APPDATA/DESCRIPTOR%%", WEBSITES[i].descriptor)
            .replace("%%APPDATA/GREETINGS%%", WEBSITES[i].greetings);

          document.body.insertAdjacentHTML("beforeend", preprocessed_msg);
          activate_event_listeners();
          break;
        }
      }

      if (window.location.href !== DEFAULT_WEBSITE) {
        console.log("User is not on default website.");
      } else {
        console.log("User is on default website.");
      }
    })
    .catch(err => console.log("Error:", err));
}

document.addEventListener("DOMContentLoaded", function () {
  checkAndShowPopup();
  setInterval(checkAndShowPopup, 30 * 60 * 1000);
});